// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1832":"59487272","5782":"b6d70103","6993":"89fdb043"}[chunkId] + ".chunk.css";
};